import Vue from 'vue'
import Router from 'vue-router'

// Pages
import Dashboard from '@/modules/Dashboard/Dashboard'
import Landing from '@/modules/Landing/Landing'

let QueryString = function (obj, prefix) {
  var str = []
  for (var p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      var k = prefix ? prefix + '[' + p + ']' : p
      var v = obj[p]
      str.push(typeof v === 'object' ? QueryString(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v))
    }
  }
  return str.join('&')
}

Router.prototype.setQueryParams = function (params) {
  let queryString = {}
  for (let query in this.currentRoute.query) {
    queryString[query] = this.currentRoute.query[query]
  }
  for (let param in params) {
    if (params[param] === null) {
      if (typeof queryString[param] !== 'undefined') {
        delete queryString[param]
      }
    } else {
      queryString[param] = params[param]
    }
  }
  this.push('?' + QueryString(queryString))
}

Vue.use(Router)

let router = new Router({
  mode: 'history', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/data',
      name: 'Data',
      component: (resolve) => require(['@/modules/Data/Data'], resolve)
    },
    {
      path: '/graphs',
      name: 'Graphs',
      component: (resolve) => require(['@/modules/Graphs/Graphs'], resolve)
    },
    {
      path: '/reporting',
      name: 'Reporting',
      component: (resolve) => require(['@/modules/Reporting/Reporting'], resolve)
    },
    {
      path: '/support',
      name: 'Support',
      component: (resolve) => require(['@/modules/Support/Support'], resolve)
    },
    {
      path: '/users',
      name: 'Users',
      component: (resolve) => require(['@/modules/Users/Users'], resolve)
    },
    {
      path: '/machines',
      name: 'Machines',
      component: (resolve) => require(['@/modules/Machines/Machines'], resolve)
    },
    {
      path: '/profile',
      name: 'Profile',
      component: (resolve) => require(['@/modules/Profile/Profile'], resolve)
    },
    { path: '*', redirect: '/' }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js